/* unplugin-vue-components disabled */import { render } from "./Toggle.vue?vue&type=template&id=07228da3&scoped=true"
import script from "./Toggle.vue?vue&type=script&lang=js"
export * from "./Toggle.vue?vue&type=script&lang=js"

import "./Toggle.vue?vue&type=style&index=0&id=07228da3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07228da3"]])

export default __exports__